module.exports = __webpack_public_path__ + "static/media/1002240.d9a295dd.png";